'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MDCChipSet = exports.MDCChipSetFoundation = exports.MDCChip = exports.MDCChipFoundation = undefined;

var _index = require('./chip/index');

var _index2 = require('./chip-set/index');

/**
 * Copyright 2017 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

exports.MDCChipFoundation = _index.MDCChipFoundation;
exports.MDCChip = _index.MDCChip;
exports.MDCChipSetFoundation = _index2.MDCChipSetFoundation;
exports.MDCChipSet = _index2.MDCChipSet;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material/chips/index.js
// module id = 1252
// module chunks = 0